import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { EmailTemplateDataService } from "src/app/services/email-template-data.service";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { ZpDataService } from "src/app/services/zp-data.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-invite-only",
    templateUrl: "./invite-only.component.html",
    styleUrls: ["./invite-only.component.scss"],
    standalone: false
})
export class InviteOnlyComponent implements OnInit {
  public activeTheme: any;
  public firstName: string;
  public lastName: string;
  public email: string;
  public confirmEmail: string;
  public message: string;
  public createAccount: boolean;
  public displayReviewForCreateAccount: boolean = false;
  public data: any;
  public editingRowIndex: number | null = null;
  public invalidEmails: number[] = [];
  public response: any[];
  public userToCreate: {
    customizedMailBody?: string;
    mailBody?: string;
    mailSubject?: string;
    reminder?: string;
    prePopulate?: boolean;
    userList?: any[];
    firstName?: string;
    lastName?: string;
    email?: string;
  };

  constructor(
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private router: Router,
    private route: ActivatedRoute,
    private api: ZpDataService,
    private emailTemplateDataService: EmailTemplateDataService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const createAccount = params["createAccount"] === "true";
      console.log("createAccount:", createAccount);
      if (createAccount) {
        console.log("createAccount is true");
        this.createAccount = true;
      } else {
        console.log("createAccount is false");
        this.createAccount = false;
      }
    });
    this.activeTheme = this.themeService.active;
  }

  saveForm() {
    if (this.validateForm()) {
      this.emailTemplateDataService.setData({
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email.toLowerCase(),
        userList: [],
      });
      if (this.createAccount == true) {
        this.displayReviewForCreateAccount = true;
        console.log(
          "displayReviewForCreateAccount:",
          this.displayReviewForCreateAccount
        );
        console.log(
          "emailTemplateDataService:",
          this.emailTemplateDataService.getData()
        );
        this.data = this.emailTemplateDataService.getData();
        this.response = [this.data];
        console.log("response:", this.response);
      } else {
        this.router.navigate(["/email-template"]);
      }
    }
  }

  validateForm(): boolean {
    if (
      !this.firstName ||
      !this.lastName ||
      !this.email ||
      !this.confirmEmail
    ) {
      this.message = "Please fill all the fields.";
      return false;
    }
    if (this.email !== this.confirmEmail) {
      this.message = "Please confirm your email correctly.";
      return false;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(this.email)) {
      this.message = "Please write your email in the right format.";
      return false;
    }
    return true; // Form is valid
  }

  editRow(index: number) {
    this.editingRowIndex = index;
  }

  saveRow(index: number, emailForm: NgForm) {
    const emailInput = emailForm.controls[`email_${index}`];

    if (emailInput && emailInput.invalid) {
      alert("Please enter a valid email.");
      return;
    }

    const email = this.response[index].data.email.toLowerCase();
    if (!this.isValidEmail(email)) {
      alert("Please enter a valid email.");
      return;
    }

    this.editingRowIndex = null;

    if (this.invalidEmails.includes(index) && this.isValidEmail(email)) {
      const invalidIndex = this.invalidEmails.indexOf(index);
      this.invalidEmails.splice(invalidIndex, 1);
    }
  }

  cancelEdit() {
    if (this.editingRowIndex !== null) {
      const email = this.response[this.editingRowIndex].data.email;
      if (!this.isValidEmail(email)) {
        alert("Please enter a valid email.");
        return;
      }
    }
    this.editingRowIndex = null;
  }

  isValidEmail(email: string): boolean {
    // Basic email validation using a regular expression
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  }

  async createUser() {
    if (this.validateForm()) {
      this.userToCreate = {
        customizedMailBody: "...",
        mailBody: "...",
        mailSubject: "...",
        reminder: "...",
        prePopulate: true,
        userList: [
          {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email.toLowerCase(),
          },
        ],
      };
    }
    const response = await this.api.sendInvites(this.userToCreate);
    console.log("response:", response);
    if (response.success && response.success === true) {
      const userId = response.users[0].Id; // Extract the Id from the response
      this.RedirectToAccountCreation(userId); // Pass the Id to the method
    }
  }

  RedirectToAccountCreation(userId: string) {
    this.router.navigate(["/account-created"], {
      queryParams: { 
        createAccount: this.createAccount,
        accountType: 'invite-only',
        userId: userId,
      },
    });
  }
}
